import { render } from "./NewThematicModal.vue?vue&type=template&id=d00212f0"
import script from "./NewThematicModal.vue?vue&type=script&lang=js"
export * from "./NewThematicModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__